import { useQuery } from '@apollo/client';
import type { UseLalSegmentsWithDetails } from '@openx/components-segment/lib/utils/context/SegmentHookTypes.ts';
import { GetLalSegmentsWithDetailsDocument } from '../../../graphql/query/segments/lal/GetLalSegmentsWithDetails.generated.tsx';

export const useLalSegmentsWithDetails: UseLalSegmentsWithDetails = ({ segmentIds }) => {
  const { loading, data: { lookalike_definitions = [] } = {} } = useQuery(GetLalSegmentsWithDetailsDocument, {
    variables: {
      segmentIds,
    },
  });

  return {
    loading,
    lalSegments: lookalike_definitions,
  };
};
